import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'wouter';

// useLayoutEffect logs a warning during SSR. Use useEffect on the server to
// keep SSR clean, useLayoutEffect on the client for synchronous scroll-reset.
const useIsoLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export function ScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useIsoLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location]);

  return null;
}
